// removed by extract-text-webpack-plugin
module.exports = {"price":"pdp-price__price__85314574","portfolio":"pdp-price__portfolio__85314574 pdp-price__price__85314574","sup":"pdp-price__sup__85314574","reduced":"pdp-price__reduced__85314574"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Price/pdp-price.scss
// module id = 678
// module chunks = 7 16 18